(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.hfPcSwatchesScrollInit) return;
    window.hfPcSwatchesScrollInit = true;

    var DRAG_THRESHOLD = 5;

    function isScrollable(container) {
      return container.scrollWidth - container.clientWidth > 4;
    }

    function onWheel(e) {
      if (e.deltaX !== 0 || e.deltaY === 0) return;
      if (!isScrollable(this)) return;
      this.scrollLeft += e.deltaY;
      e.preventDefault();
    }

    document.addEventListener('mouseover', function (e) {
      var container = e.target.closest('.hf-pc-swatches');
      if (!container || container.dataset.hfOverflowChecked) return;
      container.dataset.hfOverflowChecked = '1';
      if (isScrollable(container)) {
        container.classList.add('hf-pc-swatches--has-overflow');
        container.addEventListener('wheel', onWheel, { passive: false });
      }
    });

    document.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      var container = e.target.closest('.hf-pc-swatches');
      if (!container || !isScrollable(container)) return;

      var startX = e.clientX;
      var startLeft = container.scrollLeft;
      var moved = false;

      function onMove(ev) {
        if (ev.buttons === 0) {
          onUp();
          return;
        }
        var dx = ev.clientX - startX;
        if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
          moved = true;
          container.classList.add('is-dragging');
        }
        if (moved) {
          container.scrollLeft = startLeft - dx;
          ev.preventDefault();
        }
      }

      function onUp() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        container.classList.remove('is-dragging');
        if (moved) {
          var suppress = function (clickEv) {
            clickEv.stopPropagation();
            clickEv.preventDefault();
          };
          container.addEventListener('click', suppress, { capture: true, once: true });
          requestAnimationFrame(function () {
            container.removeEventListener('click', suppress, true);
          });
        }
      }

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.HFGalleryInit) return;
    window.HFGalleryInit = true;

    function getTriggers(gallery) {
      return Array.from(gallery.querySelectorAll('[data-hf-gallery-trigger]'));
    }

    function findGallery(modal) {
      const id = modal.getAttribute('id');
      if (!id) return null;
      return document.querySelector('[data-hf-gallery-target="#' + id + '"]');
    }

    function preloadImage(trigger) {
      if (!trigger || trigger.__hfPreloaded) return;
      const src = trigger.getAttribute('data-hf-media-src');
      if (!src) return;
      trigger.__hfPreloaded = true;
      const img = new Image();
      const srcset = trigger.getAttribute('data-hf-media-srcset');
      if (srcset) img.srcset = srcset;
      img.sizes = '100vw';
      img.src = src;
    }

    function updateProgress(modal, total, atIndex) {
      const progressBar = modal.querySelector('[data-hf-gallery-progress-bar]');
      if (!progressBar || !total) return;
      const idx = ((atIndex % total) + total) % total;
      const pct = ((idx + 1) / total * 100);
      progressBar.style.setProperty('width', pct + '%', 'important');
    }

    function preloadAdjacent(gallery, index) {
      const triggers = getTriggers(gallery);
      if (!triggers.length) return;
      const total = triggers.length;
      const prev = ((index - 1) % total + total) % total;
      const next = ((index + 1) % total + total) % total;
      preloadImage(triggers[prev]);
      preloadImage(triggers[next]);
    }

    let interactionFired = false;
    const interactionCallbacks = [];
    function onceInteraction(cb) {
      if (interactionFired) { cb(); return; }
      interactionCallbacks.push(cb);
    }
    function fireInteraction() {
      if (interactionFired) return;
      interactionFired = true;
      ['scroll', 'mousemove', 'touchstart', 'pointerdown', 'keydown'].forEach(function (evt) {
        window.removeEventListener(evt, fireInteraction);
      });
      interactionCallbacks.splice(0).forEach(function (cb) { cb(); });
    }
    ['scroll', 'mousemove', 'touchstart', 'pointerdown', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, fireInteraction, { once: true, passive: true });
    });

    function preloadGalleryAtIdle(gallery) {
      onceInteraction(function () {
        const run = function () { getTriggers(gallery).forEach(preloadImage); };
        if ('requestIdleCallback' in window) {
          requestIdleCallback(run, { timeout: 2000 });
        } else {
          setTimeout(run, 0);
        }
      });
    }

    function buildSlide(trigger) {
      const kind = trigger.getAttribute('data-hf-media-kind') || 'image';
      const alt = trigger.getAttribute('data-hf-media-alt') || '';
      const figure = document.createElement('figure');
      figure.className = 'hf-gallery-modal__slide';

      if (kind === 'image') {
        const thumb = trigger.querySelector('img.hf-gallery__img');
        if (thumb && thumb.currentSrc) {
          figure.style.backgroundImage = 'url(' + thumb.currentSrc + ')';
          figure.style.backgroundSize = 'contain';
          figure.style.backgroundPosition = 'center';
          figure.style.backgroundRepeat = 'no-repeat';
        }
        const img = document.createElement('img');
        img.src = trigger.getAttribute('data-hf-media-src') || '';
        const srcset = trigger.getAttribute('data-hf-media-srcset');
        if (srcset) img.setAttribute('srcset', srcset);
        img.setAttribute('sizes', '100vw');
        img.alt = alt;
        img.loading = 'eager';
        img.decoding = 'async';
        figure.appendChild(img);
      } else if (kind === 'video-file') {
        const video = document.createElement('video');
        const sourcesJson = trigger.getAttribute('data-hf-media-sources');
        if (sourcesJson) {
          try {
            const sources = JSON.parse(sourcesJson);
            sources.forEach(function (s) {
              const source = document.createElement('source');
              source.src = s.url;
              if (s.mime_type) source.type = s.mime_type;
              video.appendChild(source);
            });
          } catch (e) {}
        }
        video.muted = true;
        video.controls = true;
        video.autoplay = true;
        video.preload = 'metadata';
        video.setAttribute('playsinline', '');
        const poster = trigger.getAttribute('data-hf-media-poster');
        if (poster) video.poster = poster;
        video.load();
        figure.appendChild(video);
        requestAnimationFrame(function () {
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        });
      } else if (kind === 'video-url') {
        const iframe = document.createElement('iframe');
        iframe.src = trigger.getAttribute('data-hf-media-iframe') || '';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        iframe.loading = 'eager';
        iframe.title = alt;
        figure.appendChild(iframe);
      }
      return figure;
    }

    function render(modal, gallery, index, direction) {
      const triggers = getTriggers(gallery);
      if (!triggers.length) return;
      const next = ((index % triggers.length) + triggers.length) % triggers.length;
      const stage = modal.querySelector('[data-hf-gallery-stage]');
      if (!stage) return;

      modal.dataset.hfGallerySingle = triggers.length <= 1 ? 'true' : 'false';
      const prevIndex = parseInt(modal.dataset.hfGalleryCurrent, 10);
      modal.dataset.hfGalleryCurrent = String(next);

      updateProgress(modal, triggers.length, next);

      preloadAdjacent(gallery, next);

      const newSlide = buildSlide(triggers[next]);
      const oldSlides = Array.from(stage.querySelectorAll('.hf-gallery-modal__slide'));

      if (!oldSlides.length || !direction || isNaN(prevIndex)) {
        stage.innerHTML = '';
        stage.appendChild(newSlide);
        return;
      }

      const enterClass = direction === 'next' ? 'is-enter-next' : 'is-enter-prev';
      const leaveClass = direction === 'next' ? 'is-leave-next' : 'is-leave-prev';

      newSlide.classList.add(enterClass);
      stage.appendChild(newSlide);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          newSlide.classList.add('is-animating');
          newSlide.classList.remove(enterClass);
          oldSlides.forEach(function (s) {
            s.classList.remove('is-dragging');
            s.classList.add('is-animating', leaveClass);
            s.style.transform = '';
          });
        });
      });

      const cleanup = function () {
        oldSlides.forEach(function (s) {
          if (s.parentNode) s.parentNode.removeChild(s);
        });
        newSlide.classList.remove('is-animating');
      };
      let settled = false;
      newSlide.addEventListener('transitionend', function handler(e) {
        if (e.propertyName !== 'transform' || settled) return;
        settled = true;
        newSlide.removeEventListener('transitionend', handler);
        cleanup();
      });
      setTimeout(function () {
        if (!settled) {
          settled = true;
          cleanup();
        }
      }, 450);
    }

    function clearStage(modal) {
      const stage = modal.querySelector('[data-hf-gallery-stage]');
      if (stage) stage.innerHTML = '';
    }

    function openModal(modal) {
      if (modal.parentElement !== document.body) {
        modal.__hfPlaceholder = document.createComment('hf-gallery-modal-placeholder');
        modal.parentNode.insertBefore(modal.__hfPlaceholder, modal);
        document.body.appendChild(modal);
      }
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.body.classList.add('overflow-hidden');
    }

    function closeModal(modal) {
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
      clearStage(modal);
      document.body.classList.remove('overflow-hidden');
      if (modal.__hfPlaceholder && modal.__hfPlaceholder.parentNode) {
        modal.__hfPlaceholder.parentNode.replaceChild(modal, modal.__hfPlaceholder);
        modal.__hfPlaceholder = null;
      }
    }

    function bootGalleries(scope) {
      const root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll('[data-hf-gallery]').forEach(function (gallery) {
        if (gallery.__hfPreloadInit) return;
        gallery.__hfPreloadInit = true;
        preloadGalleryAtIdle(gallery);
        gallery.querySelectorAll('[data-hf-gallery-trigger]').forEach(function (trigger) {
          trigger.addEventListener('pointerenter', function () { preloadImage(trigger); });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { bootGalleries(); });
    } else {
      bootGalleries();
    }
    document.addEventListener('shopify:section:load', function (e) { bootGalleries(e.target); });
    document.addEventListener('shopify:block:load', function (e) { bootGalleries(e.target); });

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-hf-gallery-trigger]');
      if (trigger) {
        const gallery = trigger.closest('[data-hf-gallery]');
        if (!gallery) return;
        const selector = gallery.getAttribute('data-hf-gallery-target');
        if (!selector) return;
        const modal = document.querySelector(selector);
        if (!modal) return;
        const triggers = getTriggers(gallery);
        const index = triggers.indexOf(trigger);
        render(modal, gallery, index < 0 ? 0 : index);
        openModal(modal);
        return;
      }

      const modal = e.target.closest('.hf-gallery-modal');
      if (!modal) return;

      if (e.target.closest('[data-hf-gallery-close]')) {
        closeModal(modal);
        return;
      }
      if (e.target.closest('[data-hf-gallery-prev]')) {
        const gallery = findGallery(modal);
        if (!gallery) return;
        const current = parseInt(modal.dataset.hfGalleryCurrent, 10) || 0;
        render(modal, gallery, current - 1, 'prev');
        return;
      }
      if (e.target.closest('[data-hf-gallery-next]')) {
        const gallery = findGallery(modal);
        if (!gallery) return;
        const current = parseInt(modal.dataset.hfGalleryCurrent, 10) || 0;
        render(modal, gallery, current + 1, 'next');
        return;
      }
      if (e.target === modal) {
        closeModal(modal);
      }
    });

    document.addEventListener('keydown', function (e) {
      const modal = document.querySelector('.hf-gallery-modal[open]');
      if (!modal) return;
      if (e.key === 'Escape') {
        closeModal(modal);
        return;
      }
      if (modal.dataset.hfGallerySingle === 'true') return;
      if (e.key === 'ArrowLeft') {
        const gallery = findGallery(modal);
        if (!gallery) return;
        const current = parseInt(modal.dataset.hfGalleryCurrent, 10) || 0;
        render(modal, gallery, current - 1, 'prev');
      } else if (e.key === 'ArrowRight') {
        const gallery = findGallery(modal);
        if (!gallery) return;
        const current = parseInt(modal.dataset.hfGalleryCurrent, 10) || 0;
        render(modal, gallery, current + 1, 'next');
      }
    });

    let touchStartX = 0;
    let touchStartY = 0;
    let touchDragging = false;
    let touchSlide = null;
    let touchWidth = 0;

    document.addEventListener('touchstart', function (e) {
      const modal = e.target.closest('.hf-gallery-modal[open]');
      if (!modal) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDragging = false;
      touchSlide = null;
      if (modal.dataset.hfGallerySingle !== 'true') {
        const slides = modal.querySelectorAll('.hf-gallery-modal__slide:not(.is-leave-next):not(.is-leave-prev)');
        touchSlide = slides[slides.length - 1] || null;
        const stage = modal.querySelector('[data-hf-gallery-stage]');
        touchWidth = stage ? stage.clientWidth : window.innerWidth;
      }
    }, { passive: true });

    document.addEventListener('touchmove', function (e) {
      if (!touchSlide) return;
      const dx = e.touches[0].clientX - touchStartX;
      const dy = e.touches[0].clientY - touchStartY;
      if (!touchDragging) {
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) return;
        touchDragging = true;
        touchSlide.classList.add('is-dragging');
      }
      const resistance = Math.max(0.35, 1 - Math.abs(dx) / (touchWidth * 2));
      touchSlide.style.transform = 'translate3d(' + (dx * resistance) + 'px, 0, 0)';
    }, { passive: true });

    document.addEventListener('touchend', function (e) {
      const modal = e.target.closest('.hf-gallery-modal[open]');
      const slide = touchSlide;
      const wasDragging = touchDragging;
      touchSlide = null;
      touchDragging = false;
      if (!modal) return;
      if (modal.dataset.hfGallerySingle === 'true') return;

      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      const threshold = Math.min(80, touchWidth * 0.18);
      const commit = Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy);

      if (!commit) {
        if (slide && wasDragging) {
          slide.classList.remove('is-dragging');
          slide.classList.add('is-animating');
          slide.style.transform = '';
          slide.addEventListener('transitionend', function snap() {
            slide.removeEventListener('transitionend', snap);
            slide.classList.remove('is-animating');
          }, { once: true });
        }
        return;
      }

      if (slide) {
        slide.classList.remove('is-dragging');
      }
      const gallery = findGallery(modal);
      if (!gallery) return;
      const current = parseInt(modal.dataset.hfGalleryCurrent, 10) || 0;
      render(modal, gallery, dx < 0 ? current + 1 : current - 1, dx < 0 ? 'next' : 'prev');
    });

    document.addEventListener('close', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('hf-gallery-modal')) {
        var modal = e.target;
        clearStage(modal);
        document.body.classList.remove('overflow-hidden');
        if (modal.__hfPlaceholder && modal.__hfPlaceholder.parentNode) {
          modal.__hfPlaceholder.parentNode.replaceChild(modal, modal.__hfPlaceholder);
          modal.__hfPlaceholder = null;
        }
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stat"] && !Shopify.designMode) return;
  try {
    (() => {
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

    const formatValue = (n, decimals) => {
      if (decimals > 0) return n.toFixed(decimals);
      return Math.round(n).toString();
    };

    const animateNumber = (el, target, duration, decimals) => {
      const value = el.querySelector('.hf-stat__value');
      if (!value) return;
      if (reducedMotion || duration <= 0) {
        value.textContent = formatValue(target, decimals);
        return;
      }
      const start = performance.now();
      const ms = duration * 1000;
      const tick = (now) => {
        const t = Math.min((now - start) / ms, 1);
        const eased = 1 - Math.pow(1 - t, 3);
        value.textContent = formatValue(target * eased, decimals);
        if (t < 1) requestAnimationFrame(tick);
        else value.textContent = formatValue(target, decimals);
      };
      requestAnimationFrame(tick);
    };

    const setCirclePercent = (el, target, duration) => {
      const circle = el.querySelector('.hf-stat__circle');
      if (!circle) return;
      const pct = Math.max(0, Math.min(100, target));
      circle.classList.remove('hf-stat__circle--full');
      requestAnimationFrame(() => {
        circle.style.setProperty('--hf-stat-percent', String(pct));
      });
      if (pct >= 100) {
        const delay = reducedMotion || duration <= 0 ? 0 : duration * 1000;
        setTimeout(() => {
          circle.classList.add('hf-stat__circle--full');
        }, delay);
      }
    };

    const trigger = (el) => {
      if (el.dataset.hfStatTriggered === '1') return;
      el.dataset.hfStatTriggered = '1';
      const target = parseFloat(el.dataset.value) || 0;
      const duration = parseFloat(el.dataset.duration) || 0;
      const decimals = parseInt(el.dataset.decimals, 10) || 0;
      animateNumber(el, target, duration, decimals);
      setCirclePercent(el, target, duration);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trigger(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    const init = () => {
      document.querySelectorAll('.hf-stat:not([data-hf-stat-init])').forEach((el) => {
        el.dataset.hfStatInit = '1';
        observer.observe(el);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', (e) => {
      const el = e.target.classList.contains('hf-stat')
        ? e.target
        : e.target.querySelector('.hf-stat');
      if (el) {
        delete el.dataset.hfStatTriggered;
        trigger(el);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
